"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8742],{

/***/ 18788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_StarsComponent; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.esm.js
var useMediaQuery_esm = __webpack_require__(43427);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 2 modules
var Box_esm = __webpack_require__(26546);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Rating/index.esm.js
var index_esm = __webpack_require__(98855);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/ExpandMore.esm.js + 1 modules
var ExpandMore_esm = __webpack_require__(39591);
// EXTERNAL MODULE: ./components/profiles/Reviews/ReviewStatisticRow.tsx
var ReviewStatisticRow = __webpack_require__(8666);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(57419);
;// CONCATENATED MODULE: ./components/RatingBar/components/StarsComponent/default.tsx





var Default = function(param) {
    var expanded = param.expanded, averageRating = param.averageRating, review = param.review, toggleExpandedContent = param.toggleExpandedContent;
    var theme = (0,useTheme_esm/* default */.Z)();
    var isLessThenLg = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("lg"));
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
        pb: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                display: "flex",
                sx: {
                    px: {
                        lg: 2,
                        xs: 0
                    },
                    mt: 1,
                    mb: expanded ? 0 : 1
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                        value: averageRating,
                        sx: {
                            fontSize: 24
                        },
                        readOnly: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore_esm/* default */.Z, {
                        sx: !expanded ? {
                            transform: "rotate(180deg)"
                        } : {},
                        fontSize: "inherit",
                        onClick: toggleExpandedContent
                    })
                ]
            }),
            !expanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.overallExperience,
                        name: translate("reviews.overallExperience"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.bedsideManner,
                        name: translate("reviews.bedsideManner"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.explanation,
                        name: translate("reviews.explanation"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.cleanliness,
                        name: translate("reviews.cleanliness"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.friendliness,
                        name: translate("reviews.friendliness"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.waitTime,
                        name: translate("reviews.wait_time"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.facilities,
                        name: translate("reviews.facilities"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.careAndSupport,
                        name: translate("reviews.careAndSupport"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.ease,
                        name: translate("reviews.easy"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.quality,
                        name: translate("reviews.quality"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.impact,
                        name: translate("reviews.impact"),
                        noSpaceBefore: isLessThenLg
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StarsComponent_default = (Default);

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Link/Link.esm.js + 2 modules
var Link_esm = __webpack_require__(26025);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(63040);
;// CONCATENATED MODULE: ./components/RatingBar/components/StarsComponent/minimal.tsx





var Minimal = function(param) {
    var averageRating = param.averageRating, redirectHref = param.redirectHref, review = param.review, toggleExpandedContent = param.toggleExpandedContent;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var formattedReviewText = (0,react.useMemo)(function() {
        var isGermany = locale.includes("de");
        var reviewText = translate("reviews.reviews");
        return isGermany ? reviewText : reviewText.toLowerCase();
    }, [
        locale,
        translate
    ]);
    var color = "#051851";
    var formatRating = averageRating === 0 ? "-" : averageRating;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_esm/* default */.Z, {
        sx: {
            textDecoration: "none"
        },
        href: redirectHref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
            display: "flex",
            gap: "5px",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                    sx: {
                        fontSize: "24px",
                        fontWeight: 500,
                        color: color
                    },
                    children: formatRating
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                    sx: {
                        fontSize: "13px",
                        fontWeight: 500,
                        color: color,
                        paddingTop: "4px"
                    },
                    children: "/5"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                    value: averageRating,
                    sx: {
                        fontSize: 24
                    },
                    size: "low-medium",
                    readOnly: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link_esm/* default */.Z, {
                    component: "span",
                    sx: {
                        color: color
                    },
                    href: redirectHref,
                    onClick: toggleExpandedContent,
                    children: [
                        "(",
                        (ref = review === null || review === void 0 ? void 0 : review.reviewsTotal) !== null && ref !== void 0 ? ref : 0,
                        " ",
                        formattedReviewText,
                        ")"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var minimal = (Minimal);

// EXTERNAL MODULE: ./components/RatingBar/components/StarsComponent/types.ts
var types = __webpack_require__(81925);
;// CONCATENATED MODULE: ./components/RatingBar/components/StarsComponent/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var StarsComponent = function(_param) {
    var variant = _param.variant, props = _objectWithoutProperties(_param, [
        "variant"
    ]);
    if (variant === types/* Variants.minimal */.t.minimal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(minimal, _objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsComponent_default, _objectSpread({}, props));
};
/* harmony default export */ var components_StarsComponent = (StarsComponent);


/***/ }),

/***/ 81925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Variants; }
/* harmony export */ });
var Variants;
(function(Variants) {
    Variants[Variants["default"] = 0] = "default";
    Variants[Variants["minimal"] = 1] = "minimal";
})(Variants || (Variants = {}));


/***/ }),

/***/ 83207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Intro; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ./hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(19227);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(63040);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(76467);
// EXTERNAL MODULE: ./components/profiles/Intro/variants/default/index.tsx + 1 modules
var variants_default = __webpack_require__(6875);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/utils/formatters.esm.js
var formatters_esm = __webpack_require__(82708);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 2 modules
var Box_esm = __webpack_require__(26546);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Tooltip/index.esm.js
var index_esm = __webpack_require__(63759);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/SvgIcon/SvgIcon.esm.js + 1 modules
var SvgIcon_esm = __webpack_require__(46224);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/UnverifiedCurved/index.esm.js



const UnverifiedCurvedIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: 17, height: 17, viewBox: "0 0 17 17" }, props),
    react.createElement("path", { d: "M7.36869 2.14454C7.76885 1.6168 8.56221 1.6168 8.96236 2.14454L9.37993 2.69524C9.81661 3.27114 10.53 3.56664 11.246 3.4682L11.9307 3.37406C12.5868 3.28385 13.1478 3.84484 13.0576 4.50095L12.9634 5.18562C12.865 5.90162 13.1605 6.61503 13.7364 7.05171L14.2871 7.46928C14.8148 7.86943 14.8148 8.66279 14.2871 9.06295L13.7364 9.48052C13.1605 9.91719 12.865 10.6306 12.9634 11.3466L13.0576 12.0313C13.1478 12.6874 12.5868 13.2484 11.9307 13.1582L11.246 13.064C10.53 12.9656 9.81661 13.2611 9.37993 13.837L8.96236 14.3877C8.56221 14.9154 7.76885 14.9154 7.36869 14.3877L6.95113 13.837C6.51445 13.2611 5.80104 12.9656 5.08503 13.064L4.40037 13.1582L4.46847 13.6535L4.40037 13.1582C3.74425 13.2484 3.18326 12.6874 3.27347 12.0313L3.36761 11.3466C3.46606 10.6306 3.17055 9.91719 2.59465 9.48052L2.04395 9.06295C1.51622 8.66279 1.51622 7.86943 2.04395 7.46928L2.59465 7.05171C3.17055 6.61503 3.46606 5.90162 3.36761 5.18562L3.27347 4.50095C3.18326 3.84483 3.74425 3.28385 4.40036 3.37406L5.08503 3.4682C5.80103 3.56664 6.51445 3.27114 6.95113 2.69524L7.36869 2.14454Z", stroke: "#CC4F4A", fill: "#CC4F4A" }),
    react.createElement("path", { d: "M5.6864 5.809L10.6445 10.7232", stroke: "#FFFFFF", strokeWidth: "1.4", strokeLinecap: "round" }),
    react.createElement("path", { d: "M10.6227 5.78705L5.70842 10.7452", stroke: "#FFFFFF", strokeWidth: "1.4", strokeLinecap: "round" })));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/VerifiedCurved/index.esm.js



const VerifiedCurvedIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: 16, height: 17, viewBox: "0 0 18 22" }, props),
    react.createElement("path", { d: "M6.80475 2.07632C7.40498 1.28472 8.59502 1.28472 9.19525 2.07632L9.61282 2.62702C9.94033 3.05895 10.4754 3.28058 11.0124 3.20674L11.6971 3.11261C12.6812 2.97729 13.5227 3.81877 13.3874 4.80294L13.2933 5.48761C13.2194 6.02461 13.4411 6.55967 13.873 6.88718L14.4237 7.30475C15.2153 7.90498 15.2153 9.09502 14.4237 9.69525L13.873 10.1128C13.4411 10.4403 13.2194 10.9754 13.2933 11.5124L13.3874 12.1971C13.5227 13.1812 12.6812 14.0227 11.6971 13.8874L11.0124 13.7933C10.4754 13.7194 9.94033 13.9411 9.61282 14.373L9.19525 14.9237C8.59502 15.7153 7.40498 15.7153 6.80475 14.9237L6.38718 14.373C6.05967 13.9411 5.52461 13.7194 4.98761 13.7933L4.30294 13.8874C3.31877 14.0227 2.47729 13.1812 2.61261 12.1971L2.70674 11.5124C2.78058 10.9754 2.55895 10.4403 2.12702 10.1128L1.57632 9.69525C0.784723 9.09502 0.784722 7.90498 1.57632 7.30475L2.12702 6.88718C2.55895 6.55967 2.78058 6.02461 2.70674 5.48761L2.61261 4.80294C2.47729 3.81877 3.31877 2.97729 4.30294 3.11261L4.98761 3.20674C5.52461 3.28058 6.05967 3.05895 6.38718 2.62702L6.80475 2.07632Z", fill: "#1A3586" }),
    react.createElement("path", { d: "M5.22339 8.90816L6.80139 10.4862L10.774 6.51367", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" })));



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Hidden/Hidden.esm.js + 4 modules
var Hidden_esm = __webpack_require__(49889);
// EXTERNAL MODULE: ./hooks/useKeywordsMapper.ts
var useKeywordsMapper = __webpack_require__(55848);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(12814);
// EXTERNAL MODULE: ./utils/address.ts
var utils_address = __webpack_require__(46699);
// EXTERNAL MODULE: ./components/profiles/Intro/styles.ts
var styles = __webpack_require__(21684);
// EXTERNAL MODULE: ./__tests__/testUtils/constants.ts
var constants = __webpack_require__(58877);
// EXTERNAL MODULE: ./components/profiles/Intro/components/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(95916);
// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js + 21 modules
var styled_esm = __webpack_require__(84857);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(57419);
;// CONCATENATED MODULE: ./components/profiles/Intro/components/ProfileDetails.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var textColor = "#11245A";
var Label = (0,styled_esm/* default */.Z)(Typography_esm/* default */.Z)(function() {
    return {
        color: textColor,
        fontSize: "13px",
        weight: 400
    };
});
var HorizontalDelimiter = (0,styled_esm/* default */.Z)(Box_esm/* default */.Z)({
    width: "3.48px",
    height: "3.48px",
    backgroundColor: textColor,
    display: "inline-flex",
    borderRadius: "50%",
    margin: "2px 8px"
});
var InfoPoint = function(param) {
    var icon = param.icon, label = param.label, skipIcons = param.skipIcons, _sx = param.sx, sx = _sx === void 0 ? {} : _sx;
    var IconWrapper = skipIcons ? Hidden_esm/* default */.Z : react.Fragment;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
        sx: _objectSpread({
            display: "flex",
            gap: "5px",
            alignItems: "center"
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, _objectSpread({}, skipIcons ? {
                smDown: true
            } : {}, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        minWidth: "32px"
                    },
                    children: icon
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                children: label
            })
        ]
    });
};
var ProfileDetails = function(param) {
    var yearsOfExperience = param.yearsOfExperience, address = param.address, addressTotal = param.addressTotal, connections = param.connections, endorsementsFrom = param.endorsementsFrom, isBookingAvailable = param.isBookingAvailable, skipIcons = param.skipIcons, toggleBookingModal = param.toggleBookingModal, workingTime = param.workingTime, specialties = param.specialties, specialtiesTotal = param.specialtiesTotal, specialistsTotal = param.specialistsTotal, followers = param.followers;
    var isRtl = (0,react.useContext)(AppData/* AppDataContext */.R).isRtl;
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
        container: true,
        direction: "column",
        sx: {
            gap: "10px"
        },
        children: [
            isBookingAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                    onClick: toggleBookingModal,
                    sx: {
                        width: "12px",
                        height: "12px",
                        cursor: "pointer"
                    },
                    bgcolor: "#00BF7C",
                    borderRadius: "50%"
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                    onClick: toggleBookingModal,
                    sx: {
                        textDecoration: "underline",
                        cursor: "pointer"
                    },
                    children: translate("profile.intro.live_bookings_available")
                })
            }) : null,
            yearsOfExperience ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 18 19",
                    sx: {
                        width: "16px",
                        height: "16px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#shield-man-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                    children: translate("years_experience", {
                        total: yearsOfExperience
                    })
                })
            }) : null,
            address ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 16 16",
                    sx: {
                        ml: 0,
                        width: "16px",
                        height: "20px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        href: "#location-pin-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "#locations",
                        children: addressTotal > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                    display: "inline",
                                    children: "".concat(address, " ")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                                    display: "inline",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "("
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                cursor: "pointer",
                                                textDecoration: "underline"
                                            },
                                            children: translate("plus_count_more", {
                                                count: addressTotal - 1
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: ")"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                            sx: {
                                cursor: "pointer",
                                textDecoration: "underline"
                            },
                            display: "inline",
                            children: address
                        })
                    })
                })
            }) : null,
            connections ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 20 20",
                    sx: {
                        ml: 0,
                        width: "20px",
                        height: "20px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#man-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                    children: translate("connections_in_healthcare", {
                        total: connections
                    })
                })
            }) : null,
            endorsementsFrom ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 37 25",
                    sx: {
                        width: "32px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#91A8D6",
                        href: "#endorsement-group-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "#endorsements",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                display: "inline",
                                sx: {
                                    cursor: "pointer",
                                    textDecoration: "underline"
                                },
                                children: translate("profile.intro.skill_endorsed")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                            display: "inline",
                            children: [
                                " ",
                                endorsementsFrom
                            ]
                        })
                    ]
                })
            }) : null,
            workingTime ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 14 14",
                    sx: {
                        width: "16px",
                        height: "16px",
                        color: "transparent"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#clock-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                    children: workingTime
                })
            }) : null,
            (specialties === null || specialties === void 0 ? void 0 : specialties.length) && specialtiesTotal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                sx: {
                    alignItems: "flex-start"
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 19 19",
                    sx: {
                        ml: 0,
                        width: "22px",
                        height: "22px",
                        color: "transparent"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#rosette-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                    lineHeight: "22px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                            display: "inline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                                    display: "inline",
                                    children: [
                                        translate("profile.specialties"),
                                        ": "
                                    ]
                                }),
                                specialties.map(function(specialty, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                display: "inline",
                                                children: specialty
                                            }, key),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalDelimiter, {})
                                        ]
                                    });
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "#specialties",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                display: "inline",
                                sx: {
                                    cursor: "pointer",
                                    textDecoration: "underline"
                                },
                                children: translate("view_all", {
                                    count: specialtiesTotal
                                })
                            })
                        })
                    ]
                })
            }) : null,
            specialistsTotal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 16 16",
                    sx: {
                        ml: 0,
                        width: "18px",
                        height: "18px",
                        color: "transparent"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#users-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "#specialists",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                            display: "inline",
                            sx: {
                                cursor: "pointer",
                                textDecoration: "underline"
                            },
                            children: [
                                specialistsTotal,
                                " ",
                                translate("specialists.disclaimer", {
                                    count: specialistsTotal
                                })
                            ]
                        })
                    })
                })
            }) : null,
            followers ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 20 20",
                    sx: {
                        ml: 0,
                        width: "20px",
                        height: "20px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#man-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
                    isRtl: isRtl,
                    sx: {
                        "& .MuiTooltip-tooltip": {
                            height: "auto",
                            width: "auto"
                        }
                    },
                    title: translate("healthcare_followers.disclaimer", {
                        count: followers
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                            children: [
                                followers,
                                " ",
                                translate("healthcare_followers", {
                                    count: followers
                                })
                            ]
                        })
                    })
                })
            }) : null
        ]
    });
};
/* harmony default export */ var components_ProfileDetails = (ProfileDetails);

// EXTERNAL MODULE: ./components/RatingBar/components/StarsComponent/index.tsx + 2 modules
var StarsComponent = __webpack_require__(18788);
// EXTERNAL MODULE: ./components/RatingBar/components/StarsComponent/types.ts
var types = __webpack_require__(81925);
;// CONCATENATED MODULE: ./components/profiles/Intro/variants/minimal/index.tsx
function minimal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function minimal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            minimal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}















function Minimal(param) {
    var name = param.name, suffix = param.suffix, title = param.title, image = param.image, keywords = param.keywords, yearsOfExperience = param.yearsOfExperience, address = param.address, isClinic = param.isPractice, practices = param.practices, _isUnclaimed = param.isUnclaimed, isUnclaimed = _isUnclaimed === void 0 ? false : _isUnclaimed, _isEntry = param.isEntry, isEntry = _isEntry === void 0 ? false : _isEntry, _introVideoAvailable = param.introVideoAvailable, introVideoAvailable = _introVideoAvailable === void 0 ? false : _introVideoAvailable, _setVideoPlayerVisibility = param.setVideoPlayerVisibility, setVideoPlayerVisibility = _setVideoPlayerVisibility === void 0 ? function() {
        return null;
    } : _setVideoPlayerVisibility, profileAnalytics = param.profileAnalytics, _connectionsCount = param.connectionsCount, connectionsCount = _connectionsCount === void 0 ? 0 : _connectionsCount, isBookingAvailable = param.isBookingAvailable, review = param.review, recommendersString = param.recommendersString, workingTimeString = param.workingTimeString, specialtiesList = param.specialtiesList, _specialtiesCount = param.specialtiesCount, specialtiesCount = _specialtiesCount === void 0 ? 0 : _specialtiesCount, _specialistsCount = param.specialistsCount, specialistsCount = _specialistsCount === void 0 ? 0 : _specialistsCount, _followersCount = param.followersCount, followersCount = _followersCount === void 0 ? 0 : _followersCount, toggleBookingModal = param.toggleBookingModal, hideRating = param.hideRating;
    var ref5;
    var theme = (0,useTheme_esm/* default */.Z)();
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref1 = (0,react.useContext)(AppData/* AppDataContext */.R), language = ref1.language, locale = ref1.locale, isRtl = ref1.isRtl;
    var formattedConnectionsCount = (0,react.useMemo)(function() {
        return isClinic ? (0,formatters_esm/* formatNumberWithPlus */.Y)(connectionsCount) : connectionsCount;
    }, [
        isClinic,
        connectionsCount
    ]);
    var isBasicView = isEntry || isUnclaimed;
    var userTitle = (0,react.useMemo)(function() {
        var ut = name;
        if (title) {
            ut = "".concat(title, " ").concat(ut);
        }
        return ut;
    }, [
        name,
        title
    ]);
    var topLevelKeywords = (0,useKeywordsMapper/* useTopLevelKeywords */.F)(keywords || []);
    var yearsOfExperienceValue = (0,react.useMemo)(function() {
        return (0,date/* getYearsDiff */.qW)(yearsOfExperience || "");
    }, [
        yearsOfExperience
    ]);
    var defaultCountry = (0,global/* getDefaultCountry */.qH)(locale);
    var ref2 = (0,react.useMemo)(function() {
        var ref, ref4;
        var addressToTransform = address || (0,utils_address/* getAddressFromPractices */.zz)(practices);
        if (!addressToTransform) {
            return {
                address: defaultCountry,
                total: 0
            };
        }
        return address ? {
            address: (0,utils_address/* transformAddressToString */.CU)(addressToTransform, language) || defaultCountry,
            total: 1
        } : {
            address: (0,utils_address/* transformAddressToShortString */.c5)(addressToTransform, language) || defaultCountry,
            total: (practices === null || practices === void 0 ? void 0 : (ref = practices.filter) === null || ref === void 0 ? void 0 : (ref4 = ref.call(practices, utils_address/* removeVideoConsultation */.WM)) === null || ref4 === void 0 ? void 0 : ref4.length) || 1
        };
    }, [
        address,
        practices,
        language,
        defaultCountry
    ]), transformedAddress = ref2.address, addressTotal = ref2.total;
    var handleOpenVideoPlayer = (0,react.useCallback)(function() {
        if (introVideoAvailable) {
            if (window) {
                window.dataLayer.push(minimal_objectSpread({
                    event: "prf_pg_prf_vid_click",
                    cont_prf_name: userTitle
                }, profileAnalytics));
            }
            setVideoPlayerVisibility(true);
        }
    }, [
        introVideoAvailable,
        profileAnalytics,
        setVideoPlayerVisibility,
        userTitle
    ]);
    var onToggleBookingModal = (0,react.useCallback)(function() {
        toggleBookingModal === null || toggleBookingModal === void 0 ? void 0 : toggleBookingModal("book");
        if (!isClinic) {
            var ref, ref6, ref7;
            window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : (ref7 = ref.push) === null || ref7 === void 0 ? void 0 : ref7.call(ref, {
                event: "prf_pg_cont_button",
                cont_prf_name: name,
                cont_prf_type: "Specialist",
                cont_interaction_label: "live booking available",
                cont_prf_uuid: profileAnalytics === null || profileAnalytics === void 0 ? void 0 : (ref6 = profileAnalytics.profile) === null || ref6 === void 0 ? void 0 : ref6.prf_uuid
            });
        }
    }, [
        isClinic,
        name,
        profileAnalytics === null || profileAnalytics === void 0 ? void 0 : (ref5 = profileAnalytics.profile) === null || ref5 === void 0 ? void 0 : ref5.prf_uuid,
        toggleBookingModal
    ]);
    var displayTopKeyword = !isClinic && !!topLevelKeywords;
    var detailsSpecialistContent = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
            sx: {
                marginTop: "14px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProfileDetails, {
                yearsOfExperience: isClinic ? null : yearsOfExperienceValue,
                address: transformedAddress,
                addressTotal: addressTotal,
                connections: isClinic ? null : formattedConnectionsCount,
                endorsementsFrom: isClinic ? null : recommendersString,
                isBookingAvailable: !isClinic && isBookingAvailable,
                toggleBookingModal: onToggleBookingModal
            })
        });
    }, [
        addressTotal,
        formattedConnectionsCount,
        isBookingAvailable,
        isClinic,
        onToggleBookingModal,
        recommendersString,
        transformedAddress,
        yearsOfExperienceValue
    ]);
    var detailsPracticeContent = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
            sx: {
                marginTop: "10px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProfileDetails, {
                address: transformedAddress,
                addressTotal: addressTotal,
                workingTime: workingTimeString,
                specialties: specialtiesList,
                specialtiesTotal: specialtiesCount,
                specialistsTotal: specialistsCount,
                followers: followersCount
            })
        });
    }, [
        addressTotal,
        followersCount,
        specialistsCount,
        specialtiesCount,
        specialtiesList,
        transformedAddress,
        workingTimeString
    ]);
    var mainFontColor = "#051851";
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                container: true,
                alignItems: "center",
                wrap: "nowrap",
                sx: {
                    pb: {
                        xs: hideRating ? "22px" : "8px",
                        sm: "32px"
                    },
                    gap: {
                        sm: "20px",
                        xs: "10px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        handleOpenVideoPlayer: handleOpenVideoPlayer,
                        introVideoAvailable: introVideoAvailable,
                        isEntryOrUnclaimed: isBasicView,
                        id: "IntroAvatar",
                        name: name,
                        image: image,
                        title: userTitle,
                        variant: Avatar/* Variants.VARIANT2 */.t.VARIANT2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        xs: 7.4,
                        direction: "column",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                variant: "h2",
                                component: "span",
                                sx: {
                                    fontSize: "24px",
                                    fontWeight: 700,
                                    color: mainFontColor,
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: "3px",
                                    lineHeight: "20px",
                                    marginRight: "3px"
                                },
                                "data-testid": constants/* TEST_IDS.PROFILE_INTRO_AVATAR */.z7.PROFILE_INTRO_AVATAR,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                    container: true,
                                    direction: "row",
                                    alignItems: "flex-end",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_esm/* default */.Z, {
                                            fontWeight: 700,
                                            fontSize: "24px",
                                            lineHeight: "32px",
                                            fontFamily: "ES Klarheit Kurrent",
                                            color: "text.darkNavy",
                                            "data-testid": constants/* TEST_IDS.SEARCH_RESULT_CARD_FULL_NAME */.z7.SEARCH_RESULT_CARD_FULL_NAME,
                                            component: "h1",
                                            sx: {
                                                wordBreak: "break-word",
                                                minWidth: "fit-content",
                                                maxWidth: "fit-content"
                                            },
                                            children: [
                                                userTitle,
                                                isUnclaimed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
                                                    isRtl: isRtl,
                                                    sx: {
                                                        "& .MuiTooltip-tooltip": {
                                                            height: "auto",
                                                            width: "auto"
                                                        }
                                                    },
                                                    title: translate("profile.unverified"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                                        display: "inline",
                                                        component: "span",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnverifiedCurvedIcon, {
                                                            sx: {
                                                                display: "inline-block",
                                                                verticalAlign: "middle",
                                                                width: "18px",
                                                                height: "18px",
                                                                marginTop: {
                                                                    md: "-1px",
                                                                    xs: "3px"
                                                                },
                                                                marginRight: "3px",
                                                                marginLeft: "3px"
                                                            }
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
                                                    isRtl: isRtl,
                                                    sx: {
                                                        "& .MuiTooltip-tooltip": {
                                                            height: "auto",
                                                            width: "auto"
                                                        }
                                                    },
                                                    title: translate("profile.verified"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                                        display: "inline",
                                                        component: "span",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedCurvedIcon, {
                                                            sx: {
                                                                display: "inline-block",
                                                                verticalAlign: "middle",
                                                                width: "20px",
                                                                height: "22px",
                                                                marginTop: {
                                                                    md: "4px",
                                                                    xs: "7px"
                                                                },
                                                                marginRight: "3px",
                                                                marginLeft: "3px"
                                                            }
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                            display: "contents",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TopKeywordText */.Zq, {
                                                display: "inline",
                                                sx: {
                                                    fontSize: {
                                                        xs: "13px",
                                                        md: "15px"
                                                    },
                                                    paddingTop: {
                                                        xs: "6px",
                                                        md: "4px"
                                                    },
                                                    color: mainFontColor
                                                },
                                                children: suffix
                                            })
                                        })
                                    ]
                                })
                            }),
                            displayTopKeyword && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TopKeywordText */.Zq, {
                                sx: {
                                    mt: {
                                        sm: "6px"
                                    },
                                    fontSize: "18px",
                                    color: mainFontColor,
                                    lineHeight: "26px"
                                },
                                children: topLevelKeywords
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                sx: {
                                    marginLeft: "-8px"
                                },
                                children: isClinic ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                                    implementation: "css",
                                    smDown: true,
                                    children: detailsPracticeContent
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                                    implementation: "css",
                                    smDown: true,
                                    children: detailsSpecialistContent
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                implementation: "css",
                smUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                    sx: {
                        pb: "14px"
                    },
                    children: [
                        hideRating ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                            sx: {
                                p: "10px",
                                borderTop: "1px solid ".concat(theme.palette.grey[600]),
                                borderBottom: "1px solid ".concat(theme.palette.grey[600]),
                                mt: "14px",
                                pb: "14px"
                            },
                            children: isBasicView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsComponent/* default */.Z, {
                                redirectHref: "#reviews",
                                averageRating: 0,
                                review: null,
                                variant: types/* Variants.minimal */.t.minimal
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsComponent/* default */.Z, {
                                redirectHref: "#reviews",
                                averageRating: (ref3 = review === null || review === void 0 ? void 0 : review.averageRating) !== null && ref3 !== void 0 ? ref3 : 0,
                                review: review,
                                variant: types/* Variants.minimal */.t.minimal
                            })
                        }),
                        isClinic ? detailsPracticeContent : detailsSpecialistContent
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var minimal = (Minimal);

;// CONCATENATED MODULE: ./components/profiles/Intro/index.tsx
function Intro_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Intro_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Intro_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







function ProfileIntro(props) {
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var newPersistentPanelEnabled = (0,useFeatureFlags/* useFeatureFlags */.g)().newPersistentPanelEnabled;
    if (locale === global/* TENANTS.WPA */.rk.WPA) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(variants_default/* default */.Z, Intro_objectSpread({}, props));
    }
    if (newPersistentPanelEnabled) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(minimal, Intro_objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(variants_default/* default */.Z, Intro_objectSpread({}, props));
}
/* harmony default export */ var Intro = (ProfileIntro);


/***/ }),

/***/ 78168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ profiles_ProfileTabs; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js + 21 modules
var styled_esm = __webpack_require__(84857);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 2 modules
var Box_esm = __webpack_require__(26546);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Link/Link.esm.js + 2 modules
var Link_esm = __webpack_require__(26025);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Tab/Tab.esm.js + 1 modules
var Tab_esm = __webpack_require__(58341);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/system/esm/styled.esm.js + 1 modules
var esm_styled_esm = __webpack_require__(60697);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Hidden/Hidden.esm.js + 4 modules
var Hidden_esm = __webpack_require__(49889);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Tabs/Tabs.esm.js + 8 modules
var Tabs_esm = __webpack_require__(71560);
;// CONCATENATED MODULE: ./hooks/usePageScrollProgress.ts

function usePageScrollProgress() {
    var ref = (0,react.useState)(0), progress = ref[0], setProgress = ref[1];
    (0,react.useEffect)(function() {
        var trackScroll = function() {
            var windowScroll = document.body.scrollTop || document.documentElement.scrollTop;
            var scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            setProgress(windowScroll / scrollHeight * 100);
        };
        window.addEventListener("scroll", trackScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", trackScroll);
        };
    }, []);
    return progress;
};

// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(57419);
;// CONCATENATED MODULE: ./hooks/useActiveTabTracker.ts

function useActiveTabTracker(items) {
    var ref = (0,react.useState)(""), activeElement = ref[0], setActiveElement = ref[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            items.some(function(item) {
                var target = document.querySelector("#".concat(item.selector));
                if (target) {
                    var rect = target.getBoundingClientRect();
                    if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
                        setActiveElement(item.selector);
                        return true;
                    }
                }
                return false;
            });
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        items
    ]);
    return activeElement;
};

// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(63040);
// EXTERNAL MODULE: ./components/ContentTopContainer.tsx
var ContentTopContainer = __webpack_require__(39512);
// EXTERNAL MODULE: ./hooks/useVisibilityComponents.ts + 1 modules
var useVisibilityComponents = __webpack_require__(32107);
// EXTERNAL MODULE: ./components/Icons/ArrowRightIcon.tsx
var ArrowRightIcon = __webpack_require__(9871);
// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/profiles/styles.ts
var styles = __webpack_require__(15777);
;// CONCATENATED MODULE: ./components/profiles/ProfileTabs.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var TabsRoot = (0,styled_esm/* default */.Z)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        width: "100%",
        backgroundColor: theme.palette.common.white,
        borderBottom: "1px solid ".concat(theme.palette.blue[200]),
        position: "sticky",
        top: 64,
        left: 0,
        marginTop: 0,
        zIndex: 999,
        overflowX: "auto",
        "& .MuiTab-root": {
            "&:after": {
                display: "none !important"
            }
        }
    }, theme.breakpoints.down("sm"), {
        top: 48,
        borderTop: "1px solid ".concat(theme.palette.blue[200])
    });
});
var LinkComponent = (0,styled_esm/* default */.Z)(Link_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "inline-block",
        color: theme.palette.text.darkNavy,
        padding: theme.custom.SpecialistPage.profileTab.padding,
        fontSize: 15,
        fontWeight: 400,
        opacity: 1,
        flexWrap: "nowrap",
        textDecoration: "none"
    }, _defineProperty(_obj, theme.breakpoints.down("md"), {
        fontSize: theme.typography.body2.fontSize
    }), _defineProperty(_obj, theme.breakpoints.up("md"), {
        "&:hover": {
            color: theme.palette.primary.main
        }
    }), _obj;
});
var StyledTab = (0,styled_esm/* default */.Z)(Tab_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        padding: "0 !important",
        minWidth: "max-content",
        "&.Mui-active": {
            a: {
                color: "".concat(theme.palette.primary.dark, " !important"),
                fontWeight: 600,
                "&:after": {
                    // eslint-disable-next-line quotes
                    content: '""',
                    display: "block",
                    position: "absolute",
                    bottom: 0,
                    background: "",
                    width: "100%",
                    borderRadius: 4,
                    height: 4,
                    left: 0
                }
            }
        }
    };
});
var ScrollIndicator = (0,esm_styled_esm/* default */.Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "width";
    }
})(function(param) {
    var width = param.width, theme = param.theme, color = param.color;
    return _defineProperty({
        position: "absolute",
        bottom: 0,
        left: 0,
        height: 4,
        width: "".concat(width, "%"),
        background: color,
        borderRadius: 4
    }, theme.breakpoints.down("sm"), {
        height: 1,
        background: color
    });
});
function ProfileTabs(_param) {
    var specialist = _param.specialist, practice = _param.practice, _isUnclaimed = _param.isUnclaimed, isUnclaimed = _isUnclaimed === void 0 ? false : _isUnclaimed, props1 = _objectWithoutProperties(_param, [
        "specialist",
        "practice",
        "isUnclaimed"
    ]);
    var theme = (0,useTheme_esm/* default */.Z)();
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var progressIndicatorColor = (0,styles/* themedColor */.St)().progressIndicatorColor;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var visibilityComponents = (0,useVisibilityComponents/* useVisibilityComponents */.c)({
        specialist: specialist,
        practice: practice
    });
    var tabs = (0,react.useMemo)(function() {
        var profileTabs = [];
        if (visibilityComponents.about) {
            profileTabs.push({
                label: translate("about"),
                selector: "about"
            });
        }
        if (specialist) {
            if (visibilityComponents.fees) {
                profileTabs.push({
                    label: translate("fees", {
                        defaultMessage: "Fees"
                    }),
                    selector: "fees"
                });
            }
            if (visibilityComponents.location) {
                profileTabs.push({
                    label: translate("locations"),
                    selector: "locations"
                });
            }
            if (visibilityComponents.reviews) {
                profileTabs.push({
                    label: translate("reviews.reviews"),
                    selector: "reviews"
                });
            }
            if (visibilityComponents.peerRecommendations) {
                profileTabs.push({
                    label: translate("skills"),
                    selector: "endorsements"
                });
            }
        }
        if (practice) {
            if (visibilityComponents.location) {
                profileTabs.push({
                    label: translate("locations"),
                    selector: "locations"
                });
            }
            if (visibilityComponents.reviews) {
                profileTabs.push({
                    label: translate("reviews.reviews"),
                    selector: "reviews"
                });
            }
            if (visibilityComponents.specialists) {
                profileTabs.push({
                    label: translate("specialists"),
                    selector: "specialists"
                });
            }
            if (visibilityComponents.facilities || visibilityComponents.services || visibilityComponents.parking) {
                profileTabs.push({
                    label: translate("facilities"),
                    selector: "services-facilities"
                });
            }
            if (visibilityComponents.gallery) {
                profileTabs.push({
                    label: translate("gallery"),
                    selector: "gallery"
                });
            }
        }
        if (visibilityComponents.videos || visibilityComponents.articles || visibilityComponents.media) {
            profileTabs.push({
                label: translate("media_center.media"),
                selector: "media"
            });
        }
        if (visibilityComponents.faq) {
            profileTabs.push({
                label: translate("faq"),
                selector: "faq"
            });
        }
        return profileTabs;
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        specialist,
        isUnclaimed,
        practice
    ]);
    var trackingTabs = (0,react.useMemo)(function() {
        if (visibilityComponents.about) {
            return _toConsumableArray(tabs).concat([
                {
                    label: translate("about"),
                    selector: "about"
                }
            ]);
        }
        return tabs;
    }, [
        tabs,
        translate,
        visibilityComponents.about
    ]);
    var getTabIndex = (0,react.useCallback)(function(id) {
        if (tabs.findIndex(function(el) {
            return el.selector === id;
        }) === -1) {
            return false;
        }
        return tabs.findIndex(function(el) {
            return el.selector === id;
        });
    }, [
        tabs
    ]);
    var ref3 = (0,react.useState)(0), tabsValue = ref3[0], setTabsValue = ref3[1];
    var activeElement = useActiveTabTracker(trackingTabs);
    var slug = specialist && specialist.slug || practice && practice.slug;
    var isSpecialist = !!specialist;
    var scrollProgress = usePageScrollProgress();
    var onClick = function(tabLabel) {
        return function() {
            window.dataLayer.push({
                event: "prf_pg_navigaton",
                prf_navigation_label: tabLabel
            });
        };
    };
    var handleChangeSelectedTab = (0,react.useCallback)(function(_, ev) {
        return setTabsValue(+ev);
    }, []);
    (0,react.useEffect)(function() {
        var newTabIndex = getTabIndex(activeElement);
        if (newTabIndex) {
            setTabsValue(newTabIndex);
        }
    }, [
        activeElement,
        getTabIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsRoot, _objectSpread({
        component: Hidden_esm/* default */.Z
    }, props1, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_esm/* default */.Z, {
                sx: {
                    marginTop: "0 !important",
                    backgroundColor: "transparent",
                    ".MuiTabs-indicator": {
                        display: "none"
                    },
                    "& .MuiTabs-scrollButtons": {
                        height: "34px",
                        width: "34px",
                        borderRadius: "50px",
                        border: "1px solid #D5DEF9",
                        backgroundColor: "transparent",
                        padding: "8px"
                    }
                },
                value: tabsValue,
                onChange: handleChangeSelectedTab,
                component: ContentTopContainer/* default */.Z,
                maxWidth: "xl",
                ScrollButtonComponent: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, _objectSpread({
                        directionLeft: props.direction === "left",
                        style: {
                            display: props.disabled ? "none" : "flex",
                            boxShadow: "".concat(props.direction === "left" ? "4px -4px" : "-4px 0px", " 10px 0px #D5DEF94D"),
                            backgroundColor: "white",
                            zIndex: 999
                        }
                    }, props));
                },
                variant: "scrollable",
                scrollButtons: "auto",
                allowScrollButtonsMobile: true,
                children: tabs.map(function(tab, index) {
                    var ref, ref1, ref2;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(StyledTab, {
                        className: tab.selector === activeElement ? "Mui-active" : "",
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(locale, "/").concat(isSpecialist ? "specialist" : "practice", "/").concat(slug, "#").concat(tab.selector),
                            scroll: false,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComponent, {
                                sx: (ref = theme.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.SpecialistPage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.common) === null || ref2 === void 0 ? void 0 : ref2.tabBarItemHover,
                                children: tab.label
                            })
                        }),
                        value: getTabIndex(tab.selector),
                        onClick: onClick(tab.selector),
                        sx: {
                            paddingRight: index === tabs.length - 1 ? "24px" : "12px"
                        }
                    }, tab.selector);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollIndicator, {
                width: scrollProgress,
                color: progressIndicatorColor
            })
        ]
    }));
}
/* harmony default export */ var profiles_ProfileTabs = (ProfileTabs);


/***/ }),

/***/ 8666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54597);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98855);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75320);


var ReviewStatisticRow = function(param) {
    var rating = param.rating, name = param.name, _noSpaceBefore = param.noSpaceBefore, noSpaceBefore = _noSpaceBefore === void 0 ? false : _noSpaceBefore;
    if (!rating) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        sx: noSpaceBefore ? {
            pr: 2
        } : {
            px: 2
        },
        container: true,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                item: true,
                display: "flex",
                alignItems: "center",
                sx: {
                    mr: 3
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        readOnly: true,
                        value: rating,
                        sx: {
                            "& svg": {
                                width: 18,
                                height: 17
                            },
                            mr: 1
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        variant: "caption",
                        sx: {
                            m: 0
                        },
                        children: rating.toFixed(2)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                item: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    variant: "caption",
                    children: name
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReviewStatisticRow);


/***/ }),

/***/ 1147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60697);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36713);
/* harmony import */ var _ContentTopContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39512);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var SectionWrapperStyled = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("section", {
    shouldForwardProp: function(prop) {
        return prop !== "sx";
    }
})(function(param) {
    var sx = param.sx;
    return sx || {};
});
var SectionWrapper = function(param) {
    var sx = param.sx, children = param.children, id = param.id, ignoreContainer = param.ignoreContainer, _withPadding = param.withPadding, withPadding = _withPadding === void 0 ? false : _withPadding, containerRef = param.containerRef;
    var theme = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionWrapperStyled, {
        ref: containerRef,
        sx: _objectSpread({
            py: withPadding ? theme.spacing(5) : undefined
        }, sx),
        id: id,
        children: ignoreContainer ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ContentTopContainer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            maxWidth: "xl",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionWrapper);


/***/ }),

/***/ 47424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHrefLang; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35837);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _providers_AppData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63040);



var useForLocales = [
    "en-ae",
    "ar-ae"
];
var useHrefLang = function() {
    var locale = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_providers_AppData__WEBPACK_IMPORTED_MODULE_2__/* .AppDataContext */ .R).locale;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    if (useForLocales.includes(locale)) {
        return useForLocales.map(function(useForLocale) {
            return {
                rel: "alternate",
                href: "https://www.doctify.com/".concat(useForLocale).concat(router.asPath),
                hreflang: useForLocale
            };
        });
    }
    return undefined;
};


/***/ }),

/***/ 56323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GK": function() { return /* binding */ isHashString; },
/* harmony export */   "sJ": function() { return /* binding */ transformToHash; },
/* harmony export */   "sz": function() { return /* binding */ parseHashFromString; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var isHashString = function(path) {
    return path.includes("#") && path.includes("=");
};
var parseHashFromString = function(path) {
    if (!isHashString) {
        return {};
    }
    var hash = path.split("#")[1].replace(/\+/g, " ");
    var couples = hash.split("&").map(function(h) {
        return decodeURIComponent(h);
    });
    return couples.map(function(c) {
        return c.split("=");
    }).reduce(function(prev, param) {
        var _param = _slicedToArray(param, 2), k = _param[0], v = _param[1];
        return v ? _objectSpread({}, prev, _defineProperty({}, k, v)) : prev;
    }, {});
};
var transformToHash = function(data) {
    var hashArray = [];
    Object.entries(data).forEach(function(param) {
        var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
        if (value && Array.isArray(value) && value.length) {
            value.forEach(function(item) {
                hashArray.push("".concat(encodeURIComponent(key), "[]=").concat(encodeURIComponent(String(item))));
            });
        } else if (value && !Array.isArray(value)) {
            hashArray.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value))));
        }
    });
    return hashArray.join("&");
};



/***/ }),

/***/ 88726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BE": function() { return /* binding */ getHashFromString; },
/* harmony export */   "DD": function() { return /* binding */ tenantForChip; },
/* harmony export */   "ST": function() { return /* binding */ isActualFilters; },
/* harmony export */   "Uk": function() { return /* binding */ getRoundedReviewValue; }
/* harmony export */ });
/* harmony import */ var _hash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56323);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76467);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var getValidSort = function(sort) {
    if (sort === "desc" || sort === "asc" || sort === "bestRated" || sort === "worstRated" || sort === null) {
        return sort;
    }
    return "desc";
};
var getRoundedReviewValue = function(reviewValue) {
    var roundValue = 4 // 0.25
    ;
    if (!reviewValue || typeof reviewValue !== "number") {
        return 0;
    }
    return Math.floor(reviewValue * roundValue) / roundValue;
};
var getHashFromString = function(path) {
    var ref = (0,_hash__WEBPACK_IMPORTED_MODULE_1__/* .isHashString */ .GK)(path) ? (0,_hash__WEBPACK_IMPORTED_MODULE_1__/* .parseHashFromString */ .sz)(path) : {}, _sort = ref.sort, sort = _sort === void 0 ? "desc" : _sort, _keyword = ref.keyword, keyword = _keyword === void 0 ? "" : _keyword, _search = ref.search, search = _search === void 0 ? "" : _search;
    return {
        sort: getValidSort(sort),
        keyword: keyword,
        search: search
    };
};
var isActualFilters = function(routerFilters, filters) {
    var ref = typeof routerFilters === "string" ? getHashFromString(routerFilters) : routerFilters, sort = ref.sort, keyword = ref.keyword, search = ref.search;
    return sort === filters.sort && keyword === filters.keyword && search === filters.search;
};
var tenantForChip = function(tenant) {
    if (!tenant) {
        return null;
    }
    var objTenant = _defineProperty({}, _constants_global__WEBPACK_IMPORTED_MODULE_0__/* .TENANTS.AR_UAE */ .rk.AR_UAE, _constants_global__WEBPACK_IMPORTED_MODULE_0__/* .TENANTS.EN_UAE */ .rk.EN_UAE);
    var _tenant;
    return (_tenant = objTenant[tenant]) !== null && _tenant !== void 0 ? _tenant : tenant;
};



/***/ })

}]);